import { sniff } from '@/util'

export default {
    home: '/pages/index/index', //  首页
    videoReplay: '/pages/live/play-back', //  视频回放页拼接
    breakingChristmasCarnival: '/pages/product-detail/product-detail', // 圣诞节活动页
    merchant: '/pages/merchant/detail', // 商家主页
    breakingDetail: '/pages/product-detail/product-detail',// bk
    bidDetail: '/pages/bid/bid', // 拍卖
    bidDetailNew: '/pages/auction/auction', // 拍卖商品详情(新)
    bidList: '/pages/bid-list/bid-list', // 拍卖首页
    goodCardDetail: '/pages/index/index', // 好卡 /pages/goodcard/detail
    myGoodCard: '/pages/index/index', // 我的中卡 /pages/gain/list
    boxList: '/pages/index/index', // 范盒-首页 /pages/fansbox-list/fansbox-list
    boxDetail: '/pages/index/index', // 范盒-福盒 /pages/fansbox/fansbox
    bagDetail: '/pages/index/index', // 范盒-福袋 /pages/fansbox/detail-bag
    normalDetail: '/pages/index/index', // 范盒-标品 /pages/fansbox/detail-normal
    articleDetail: '/pages/article/article', // 资讯详情
    videoLive: '/pages/live/living', //  视频直播页拼接
    marketing: '/pages/index/index', // 拼团页 /pages/marketing/marketing
    evaluationList: '/pages/evaluation-list/evaluation-list', // 送评页
    couponList: '/pages/coupon/couponList', // 优惠列表页
    scoreProductDetail: '/pages/score-product/detail', // 积分商品详情页
    fansGoProductDetail: '/pages/fansgo-product/detail', // fansgo商品详情页
    allCardList: '/pages/bid/all-card-list', // 全部好卡
    orderCreate: '/pages/Order/OrderCreate', // 订单确认页
    c2cMerchantOrderDetail: '/pages/c2c-merchant/order-detail', // 卖家视角订单详情
    c2cOrderDetail: '/pages/order-detail/order-detail', // 买家视角订单详情
    bkSameSeries: '/pages/index/index', // 同系列好卡 /pages/Breaking/sameSeries
    bkCardListActivity: '/pages/index/index', // 卡片查看列表 /pages/card/CardListActivity
    tempstorage: '/pages/index/index', // fans购扭卡机暂存柜 /pages/mine/tempstorage
    c2cMerchantIndex: '/pages/c2c-merchant/merchantshop', // C2C商家店铺主页
    orderDetail: '/pages/order-detail/order-detail', // 订单详情
    lotteryOrderIndex: '/pages/exchange/order-detail', // 合成订单详情
    logisticsDetail: '/pages/logistics/detail', // 物流详情
    lotteryIndex: '/pages/lottery/lottery-index', // fans购扭卡机主页
    // ip
    ipProductDetail: '/pages/ip-product/detail',
    // ip抽卡机
    ipMachineOrder: '/pages/lottery/ip-lottery-order-list', // 抽卡机订单列表
    ipMachineExchange: '/pages/lottery/exchange-order-list', // 兑换订单列表
    ipMachineSendList: '/pages/lottery/ip-lottery-send-order-list', // 发货订单列表
    ipMachineHome: sniff.isWechatMiniProgram ? '/packageMachine/machine' :  '/pages/lottery/ip-lottery-detail', // 抽开机详情
    //  设置相关
    addressManagement: '/pages/mine-index/address-management',
    // h5 machine == app lotteryMall ipM
    ipMachineProductDetail: '/page/lottery/fragment-lotteryMall-detail', // 碎片商城商品 分享页
    // 锦鲤订单 里程碑
    lotteryOrderList: '/pages/fansbox-lottery/order-list',
}
